export class PobierzUzytkownikowFiltr {
    wartoscSzukaj: string;
    aktywni: boolean;
}